// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"Login_modal_title__xX_H6","input_title":"Login_input_title__2z7ie","button_wrapper":"Login_button_wrapper__3ejMR"};